import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../utils/api';

const AccessibilityContext = createContext(null);

export const useAccessibility = () => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within AccessibilityProvider');
  }
  return context;
};

export const AccessibilityProvider = ({ children }) => {
  const { user } = useAuth();
  const [accessibilityMode, setAccessibilityMode] = useState(false);

  useEffect(() => {
    if (user) {
      setAccessibilityMode(user.accessibility_mode || false);
    }
  }, [user]);

  const toggleAccessibility = async () => {
    const newMode = !accessibilityMode;
    setAccessibilityMode(newMode);
    
    // Save to backend
    try {
      await api.put('/auth/profile', {
        accessibility_mode: newMode
      });
    } catch (error) {
      console.error('Error updating accessibility mode:', error);
    }
    
    // Apply to document
    if (newMode) {
      document.documentElement.classList.add('accessibility-mode');
    } else {
      document.documentElement.classList.remove('accessibility-mode');
    }
  };

  // Apply class on mount
  useEffect(() => {
    if (accessibilityMode) {
      document.documentElement.classList.add('accessibility-mode');
    } else {
      document.documentElement.classList.remove('accessibility-mode');
    }
  }, [accessibilityMode]);

  const value = {
    accessibilityMode,
    toggleAccessibility
  };

  return (
    <AccessibilityContext.Provider value={value}>
      {children}
    </AccessibilityContext.Provider>
  );
};
